'use strict';
module.exports = require('./InputText.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/inputtext/index.js
// module id = 4
// module chunks = 1